import { Button, Modal } from "app/components";
import { get, isNil } from "lodash";
import { rCustomBlocks, rFetchingBlockIds } from "app/utils/recoil";
import { useEffect, useState } from "react";

import { AdminForm } from "app/adminApp/components";
import { blockConfigs } from "app/adminApp/blockConfigs";
import { safeArray } from "app/utils/utils";
import { spreadsheetSelect } from "app/adminApp/blockConfigs/shared";
import useActiveBlock from "app/utils/useActiveBlock";
import { useRecoilValue } from "recoil";
import useSetBlock from "app/utils/useSetBlock";

const BlockWizard = () => {
  const setBlock = useSetBlock();

  const activeBlock = useActiveBlock();

  const activeBlockConfig = get(blockConfigs, get(activeBlock, "componentId"));

  const [hasIncompleteResources, setHasIncompleteResources] = useState(false);

  const fetchingBlockIds = useRecoilValue(rFetchingBlockIds);

  const blockIsFetching = fetchingBlockIds.includes(activeBlock.id);

  let wizardResources = get(activeBlockConfig, "resources", [])
    .filter((r) => r.wizard)
    .map((r) => ({
      ...r,
      label: get(r, "wizardLabel", null) || get(r, "label", null),
      section: null,
      orientation: "vertical",
      width: "100%",
      value: get(activeBlock, r.id),
    }))
    .filter(
      (f) => !f.requiresSheet || (f.requiresSheet && activeBlock.spreadsheet)
    )
    .filter(
      (f) =>
        !f.displayCondition ||
        (f.displayCondition && f.displayCondition(activeBlock))
    );

  const customBlocks = useRecoilValue(rCustomBlocks);
  const matchingCustomBlock = safeArray(customBlocks).find(
    (b) => b.id === get(activeBlock, "customBlock")
  );
  const repeatingCustomBlock = get(matchingCustomBlock, "repeating");
  if (repeatingCustomBlock) {
    wizardResources.push({
      ...spreadsheetSelect,
      section: null,
      value: get(activeBlock, "spreadsheet"),
    });
  }

  const incompleteResources = wizardResources.filter((r) =>
    isNil(get(activeBlock, r.id))
  );

  useEffect(() => {
    if (incompleteResources.length > 0) {
      setHasIncompleteResources(true);
    }
  }, [activeBlock.id]);

  if (hasIncompleteResources) {
    return (
      <Modal
        hide={() => setHasIncompleteResources(false)}
        background="var(--grey1)"
        minWidth="350px"
        header={{
          title: `Finalize ${get(activeBlock, "componentId")} Setup`,
          description: "Complete the required fields below",
        }}
      >
        <AdminForm
          labelStyle={"headingSm"}
          margin="10px 0 0 0"
          sectionPadding={"0px"}
          onChange={(k, v) => setBlock({ data: { ...activeBlock, [k]: v } })}
          fields={wizardResources}
        />
        <Button
          data={{
            text: "Complete Setup",
            width: "100%",
            disabled: incompleteResources.length > 0,
            margin: "15px 0 0 0",
            isFetching: blockIsFetching,
            onClick: () => setHasIncompleteResources(false),
          }}
        />
      </Modal>
    );
  }

  return <></>;
};

export default BlockWizard;
